"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scrollManager = void 0;
var ScrollManager = /** @class */ (function () {
    function ScrollManager() {
    }
    ScrollManager.prototype.varructor = function () {
        this.scrollPosition = 0;
    };
    ScrollManager.prototype.scrollOn = function () {
        setTimeout(function () {
            document.body.style.cssText = "";
            document.documentElement.style.scrollBehavior = '';
        }, 50);
    };
    ScrollManager.prototype.scrollOff = function () {
        this.scrollPosition = window.scrollY;
        document.body.style.cssText = "\n            overflow: hidden;\n            padding-right: ".concat(window.innerWidth - document.body.offsetWidth, "px;\n            height: 100vh;\n            width: 100vw;\n            ");
        document.documentElement.style.scrollBehavior = 'unset';
    };
    ScrollManager.prototype.resetScrollPosition = function () {
        this.scrollPosition = 0;
    };
    return ScrollManager;
}());
exports.scrollManager = new ScrollManager();
